import React, { Component, useReducer } from "react";
import ReactDOM from "react-dom";
import {Transition} from 'react-spring/renderprops'

import { SuppedPrice } from "./components/SuppedPrice";
import {hasPrimeLocal} from "./helpers";
//DF: use wp.element

const initialState = {
    selectedProducts: {},
    totalRegularPrice: 0,
    totalBundlePrice: 0,
    totalProductsSelected: 0,
    shopURL: '',
    selectedIDs: [],
    bundleSelected:false
};

const SELECT_PRODUCT = 'selectProduct';
const DESELECT_PACK = 'deselectPack';

function buildBundle(state, action) {
    let newState;

    /*
        Make selections
     */
    switch (action.type) {
        case SELECT_PRODUCT:
            newState = {...state};
            if (newState.selectedProducts[action.product.productType] === action.product) {
                delete newState.selectedProducts[action.product.productType];
            } else {
                newState.selectedProducts[action.product.productType] = action.product;
            }
            break;

        case DESELECT_PACK:
            newState = {...state};
            if (newState.selectedProducts[action.productType] !== null) {
                delete newState.selectedProducts[action.productType];
            } else {
                return state; //Nothing changed
            }
            break;
    }


    /*
        Calculate new price total and shop URL
     */
    newState.totalRegularPrice = 0;
    newState.totalBundlePrice = 0;
    newState.totalProductsSelected = 0;
    newState.shopURL = '';
    let selectedProductIDs = [];
    Object.keys(newState.selectedProducts).map((productType, i) => {
        if (newState.selectedProducts[productType]) {
            newState.totalRegularPrice += Number.parseFloat(newState.selectedProducts[productType].price);
            newState.totalBundlePrice += Number.parseFloat(newState.selectedProducts[productType].bundlePrice);
            newState.totalProductsSelected++;
            selectedProductIDs.push(newState.selectedProducts[productType].id)
        }
    });
    //In the exceptional case when only 2 products are selected and one of them is PRIME LOCAL the bundle discount is not applied
    if (selectedProductIDs.length === 2 && hasPrimeLocal(newState.selectedProducts)) {
        newState.totalBundlePrice = newState.totalRegularPrice; //remove discount
    }

    newState.selectedIDs = selectedProductIDs;

    newState.shopURL = '?revaction=customBundle&revdata=' + encodeURIComponent(JSON.stringify({ids: selectedProductIDs}));

    if (newState.totalProductsSelected >= 2) {
        newState.bundleSelected = true;
    } else {
        newState.bundleSelected = false;
    }

    console.log(newState);

    return newState;
}

function BundleBuilder(props) {

    const [state, dispatch] = useReducer(buildBundle, initialState);

    const packs = Rev.bundleBuilder[props.id];

    return  (
        <div className="container bundle-builder">
            <div className="row heading">
                <div className="col-12">
                    <div className="content">
                        <h4>MAKE YOUR OWN BUNDLE</h4>
                        <p>We're all about your needs. So that's why you can choose your very own custom bundle.<br/>
                            Simply pick one option from each category below and you're all set.</p>
                    </div>
                </div>
            </div>
            <div className="row no-gutters selector">
                {packs.map((pack, i) => {
                    let productType = '';
                    switch (pack.parent.productType) {
                        case 'tv':
                            productType = 'TV';
                            break;
                        case 'net':
                            productType = 'internet';
                            break;
                        case 'talk':
                            productType = 'phone';
                            break;
                    }
                    let sectionSelected = !(state.selectedProducts[pack.parent.productType]);

                    return (
                        <div className={"col-md-4 col-sm-12 product-type-" + pack.parent.productType} key={pack.parent.id}>
                            <h5 dangerouslySetInnerHTML={{__html: pack.parent.title}} />
                            <div className="products">
                                {pack.children.map((child, j) => {
                                    const priceDecimal = Math.floor(child.price);
                                    const priceFraction = Number.parseFloat(child.price - priceDecimal).toFixed(2).substring(2);
                                    let productClass = "product clearfix has-border color-theme-";
                                    let themeColor = child.colorTheme;
                                    let selected = true;
                                    if (!(state.selectedProducts[child.productType]) || (state.selectedProducts[child.productType].id !== child.id)) {
                                        themeColor = 'grey';
                                        selected = false;
                                    }
                                    productClass +=  themeColor;

                                    return (
                                        <div className={productClass} key={child.id} onClick={e => dispatch({ type: SELECT_PRODUCT, product: child })}>
                                            <header className="d-flex has-border">
                                                <div className="cell left flex-fill has-border">
                                                    <h5 className="" dangerouslySetInnerHTML={{__html: child.title}} />
                                                    <div className="highlight" dangerouslySetInnerHTML={{__html: child.highlight}} />
                                                </div>
                                                <div className="cell right">
                                                    ${priceDecimal}<sup>.{priceFraction}</sup>
                                                </div>
                                            </header>
                                            <footer className="">
                                                <div className="cell">
                                                    <a href="#" onClick={e => e.preventDefault()} className={"has-color "}>
                                                        <div className={"status-text " + (selected ? 'flip-horizontal-bottom' : 'flip-horizontal-bottom-reverse')}>
                                                            <div className="front face">
                                                                <div className="text">Select</div>
                                                            </div>
                                                            <div className="back face">
                                                                <div className="text">Selected</div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </footer>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className={"pack-summary " + ((sectionSelected)?'section-selected':'')}>
                                <a href="#" onClick={e => {e.preventDefault(); dispatch({ type: DESELECT_PACK, productType: pack.parent.productType })}}> I don't need {productType}</a>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="row bundle-summary purchase-start">
                <div className="col-12 d-flex">
                    <div className="container d-flex my-auto flex-md-nowrap flex-sm-wrap">
                        <div className="go-back-button wp-block-button aligncenter is-style-outline my-auto">
                            <button className="wp-block-button__link has-text-color has-light-red-color arrow-back">Go back</button>
                        </div>
                        <Transition items={state.bundleSelected} from={{opacity:0}} enter={{opacity:1}} leave={{opacity:0}} >
                            {bundleSelected =>
                                (bundleSelected)
                                    ? props => (
                                            <>
                                                <div className="bundle-price flex-fill d-flex my-auto" style={props}>
                                                    <p className="heading flex-fill my-auto"><span>Your <strong>REV</strong> Bundle</span></p>
                                                    <p className="cost-info flex-fill my-auto">
                                                        {/* In a rare case where bundle and regular prce are same we don't show crossed regular price */}
                                                        {(state.totalRegularPrice !== state.totalBundlePrice) &&
                                                        <span className="regular-price-amount"><span className="full crossed has-light-red-color">&nbsp;</span><SuppedPrice number={state.totalRegularPrice} force={true} anim={true} unit={'$'} /></span>
                                                        }
                                                        <span className="bundle-price-amount"><SuppedPrice number={state.totalBundlePrice} force={true} anim={true} unit={'$'} /></span>
                                                        <span className="monthly-cost align-self-end">monthly cost</span>
                                                    </p>
                                                </div>
                                                <div className="continue-button wp-block-button aligncenter is-style-outline has-white-background-color my-auto"  style={props}>
                                                    <a href={"/purchase" + state.shopURL} data-rev-purchase-id={JSON.stringify(state.selectedIDs)} className="wp-block-button__link has-text-color has-light-red-color has-white-background-color">Continue</a>
                                                </div>
                                            </>
                                        )
                                    : props => (
                                        <div className="cta has-white-color my-auto flex-fill center select-two"  style={props}>
                                            <p className="monthly-cost">Select at least 2 products to make a bundle</p>
                                        </div>
                                    )
                            }
                        </Transition>
                    </div>
                </div>
            </div>
        </div>
    );
}
// export default bundleBuilder;

Rev.bundleBuilder_Component = BundleBuilder; //Save component into a globally accessible container so it can be accessed from wp editor callbacks when block is displayed in CMS
if (typeof Rev.bundleBuilder !== 'undefined') { //Defined only in front end. Has data for each bundle builder on a page.
    Object.keys(Rev.bundleBuilder).forEach(function (item) {
        //DF: use wp.element instead
        ReactDOM.render(
            <BundleBuilder id={item} />,
            document.getElementById(item)
        );
    });
}

